import { render } from "./Forminput.vue?vue&type=template&id=45093c99"
import script from "./Forminput.vue?vue&type=script&lang=js"
export * from "./Forminput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__